/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Profile_Editors_Logout_HelperInputs */

const en_us2_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your workouts and answers stay saved. To come back, sign in with ${i?.email}.`)
};

const pt_br2_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seus treinos e respostas continuam salvos. Para voltar, entre com ${i?.email}.`)
};

const es_419_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tus entrenamientos y respuestas quedan guardados. Para volver, entra con ${i?.email}.`)
};

const pt_pt2_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Os teus treinos e respostas continuam guardados. Para voltares, entra com ${i?.email}.`)
};

const fr_fr2_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tes séances et tes réponses restent enregistrées. Pour revenir, connecte-toi avec ${i?.email}.`)
};

const de_de2_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deine Trainings und Antworten bleiben gespeichert. Um zurückzukommen, melde dich mit ${i?.email} an.`)
};

const it_it2_profile_editors_logout_helper = /** @type {(inputs: Profile_Editors_Logout_HelperInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I tuoi allenamenti e le tue risposte restano salvati. Per tornare, accedi con ${i?.email}.`)
};

/**
* | output |
* | --- |
* | "Your workouts and answers stay saved. To come back, sign in with {email}." |
*
* @param {Profile_Editors_Logout_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_logout_helper = /** @type {((inputs: Profile_Editors_Logout_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Logout_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_logout_helper(inputs)
	if (locale === "es-419") return es_419_profile_editors_logout_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_logout_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_logout_helper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_logout_helper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_logout_helper(inputs)
	return en_us2_profile_editors_logout_helper(inputs)
});
export { profile_editors_logout_helper as "profile-editors.logout_helper" }